var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 3.333a.667.667 0 0 0-1.333 0h1.333zm-1.333 9.334a.667.667 0 1 0 1.333 0H7.334zm-4-5.333a.667.667 0 1 0 0 1.333V7.334zm9.333 1.333a.667.667 0 1 0 0-1.333v1.333zM7.334 3.334v9.333h1.333V3.334H7.334zm-4 5.333h9.333V7.334H3.334v1.333z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1b0dbaf8171899d885adb2925e421829.svg";
export { ForwardRef as ReactComponent };